import { NgModule } from '@angular/core';
import { Readmore2Component } from './readmore2.component';

@NgModule({
	declarations: [Readmore2Component],
	imports: [],
	exports: [Readmore2Component],
})
export class Readmore2Module {}
